module.exports = __webpack_public_path__ + "media/assets/images/tour/5a_Tour_3-b96d90a7784e5e531237399c185c4bd2.png";